import { render } from "./ProductsSectionComponent.vue?vue&type=template&id=707db5f8&scoped=true&ts=true"
import script from "./ProductsSectionComponent.vue?vue&type=script&lang=ts"
export * from "./ProductsSectionComponent.vue?vue&type=script&lang=ts"

import "./ProductsSectionComponent.vue?vue&type=style&index=0&id=707db5f8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-707db5f8"]])

export default __exports__